// extracted by mini-css-extract-plugin
export var downArrow = "_b7-0";
export var label = "_b7-1";
export var treatmentCard = "_b7-3";
export var upArrow = "_b7-2";